<template>
  <div class="auth-shell">
    <div class="auth-orb auth-orb--blue"></div>
    <div class="auth-orb auth-orb--violet"></div>

    <main class="auth-layout">
      <section class="auth-panel">
        <div class="auth-header">
          <div class="brand-mark">T</div>
          <div class="brand-copy">
            <p class="eyebrow">thxily</p>
            <h1 class="title">管理コンソールにログイン</h1>
            <p class="description">
              テナントID、メールアドレス、パスワードを入力して管理画面へ進みます。
            </p>
          </div>
        </div>

        <div class="auth-summary">
          <div class="summary-item">
            <span class="summary-label">必要情報</span>
            <span class="summary-value">Tenant ID / Email / Password</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">ログイン先</span>
            <span class="summary-value">Admin Dashboard</span>
          </div>
        </div>

        <form class="auth-form" @submit.prevent="login">
          <div class="form-group">
            <label class="form-label" for="tenantcd">Tenant ID</label>
            <input
              id="tenantcd"
              v-model="tenantcd"
              type="text"
              class="form-input"
              placeholder="tenant-001"
              autocomplete="organization"
              required
            />
          </div>

          <div class="form-group">
            <label class="form-label" for="userid">Email</label>
            <input
              id="userid"
              v-model="userid"
              type="email"
              class="form-input"
              placeholder="name@example.com"
              autocomplete="username"
              required
            />
          </div>

          <div class="form-group">
            <label class="form-label" for="password">Password</label>
            <input
              id="password"
              v-model="password"
              type="password"
              class="form-input"
              placeholder="••••••••"
              autocomplete="current-password"
              required
            />
          </div>

          <button type="submit" class="submit-button" :disabled="loading">
            <span v-if="!loading">ログイン</span>
            <span v-else class="spinner" aria-label="loading"></span>
          </button>
        </form>
      </section>
    </main>
  </div>
</template>

<script>
import store from "../store";
import qs from "qs";

export default {
  data() {
    return {
      tenantcd: "",
      userid: "",
      password: "",
      loading: false,
    };
  },
  methods: {
    async login() {
      this.loading = true;
      try {
        await store.dispatch(
          "logIn",
          qs.stringify({
            client_id: this.tenantcd,
            username: this.userid,
            password: this.password,
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

:global(body) {
  margin: 0;
  background:
    radial-gradient(circle at top left, rgba(79, 142, 247, 0.18), transparent 30%),
    radial-gradient(circle at bottom right, rgba(124, 92, 252, 0.12), transparent 24%),
    linear-gradient(180deg, #edf2f8 0%, #dde2ec 100%);
  color: #1e293b;
}

.auth-shell {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.auth-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(12px);
  pointer-events: none;
  opacity: 0.85;
}

.auth-orb--blue {
  width: 20rem;
  height: 20rem;
  top: -6rem;
  right: -5rem;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.24), rgba(59, 130, 246, 0));
}

.auth-orb--violet {
  width: 16rem;
  height: 16rem;
  left: -4rem;
  bottom: -4rem;
  background: radial-gradient(circle, rgba(124, 92, 252, 0.16), rgba(124, 92, 252, 0));
}

.auth-layout {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
}

.auth-panel {
  width: min(100%, 520px);
  padding: 34px 32px 30px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(10px);
}

.auth-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.brand-mark {
  width: 54px;
  height: 54px;
  border-radius: 18px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #4f8ef7, #7c5cfc);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 800;
  box-shadow: 0 14px 30px rgba(79, 142, 247, 0.24);
}

.brand-copy {
  flex: 1;
}

.eyebrow {
  margin: 2px 0 10px;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.title {
  margin: 0;
  font-size: 1.65rem;
  line-height: 1.4;
  color: #0f172a;
}

.description {
  margin: 12px 0 0;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.8;
}

.auth-summary {
  display: grid;
  gap: 10px;
  margin-top: 24px;
  padding: 16px 18px;
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(239, 246, 255, 0.9), rgba(248, 250, 252, 0.9));
  border: 1px solid #dbeafe;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
}

.summary-label {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.summary-value {
  color: #1e3a8a;
  font-size: 0.86rem;
  font-weight: 700;
  text-align: right;
}

.auth-form {
  display: grid;
  gap: 18px;
  margin-top: 24px;
}

.form-group {
  display: grid;
  gap: 8px;
}

.form-label {
  color: #334155;
  font-size: 0.88rem;
  font-weight: 700;
}

.form-input {
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
  font: inherit;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.form-input::placeholder {
  color: #94a3b8;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.14);
  background: #fff;
}

.submit-button {
  min-height: 50px;
  margin-top: 2px;
  border: none;
  border-radius: 16px;
  background: #3b82f6;
  color: #fff;
  font: inherit;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  box-shadow: 0 14px 24px rgba(59, 130, 246, 0.2);
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease, background 0.18s ease;
}

.submit-button:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 18px 28px rgba(37, 99, 235, 0.24);
}

.submit-button:disabled {
  cursor: not-allowed;
  opacity: 0.72;
}

.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 640px) {
  .auth-layout {
    padding: 20px 14px;
  }

  .auth-panel {
    padding: 26px 18px 22px;
    border-radius: 22px;
  }

  .auth-header {
    flex-direction: column;
  }

  .summary-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .summary-value {
    text-align: left;
  }
}
</style>
